var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadmapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 51,
    viewBox: "0 0 44 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2656 35.7837L23.1266 34.3394L30.1197 48.1998L27.2587 49.6441L20.2656 35.7837Z",
    fill: "url(#paint0_linear_4821_17473)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79688 35.874L12.2011 34.564L13.7355 37.3785L11.3313 38.6885L9.79688 35.874Z",
    fill: "url(#paint1_linear_4821_17473)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82422 39.6758L7.56503 37.0928L9.09901 39.9065L4.3582 42.4895L2.82422 39.6758Z",
    fill: "url(#paint2_linear_4821_17473)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6035 40.3132L39.4437 33.2993L41.1849 35.9891L30.3447 43.003L28.6035 40.3132Z",
    fill: "url(#paint3_linear_4821_17473)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0762 26.141L34.1373 22.9043L35.6477 25.7308L29.5866 28.9676L28.0762 26.141Z",
    fill: "url(#paint4_linear_4821_17473)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.426 31.4764C21.9111 31.4764 21.4282 31.2307 21.1269 30.8141C21.0287 30.6795 18.6976 27.449 16.326 23.5175C12.9908 17.9882 11.3691 14.0845 11.3691 11.5887C11.3691 5.48889 16.3303 0.527344 22.4261 0.527344C28.5219 0.527344 33.4831 5.48851 33.4831 11.5887C33.4831 14.0864 31.8614 17.9877 28.5262 23.5175C26.1546 27.4489 23.8235 30.6773 23.7253 30.8141C23.424 31.2307 22.9411 31.4764 22.4262 31.4764H22.426ZM22.426 3.73252C18.0972 3.73252 14.5743 7.25576 14.5743 11.5886C14.5743 14.6205 18.9628 22.0346 22.4244 27.0875C25.8856 22.0323 30.2761 14.6161 30.2761 11.5886C30.2782 7.2556 26.755 3.73252 22.426 3.73252Z",
    fill: "url(#paint5_linear_4821_17473)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4225 36.8528C19.9184 36.8528 17.5382 36.2909 15.7221 35.2717C13.6154 34.088 12.4531 32.4129 12.4531 30.552C12.4531 29.0435 13.2565 27.5992 14.7158 26.4903C15.9614 25.5438 17.6301 24.8579 19.5423 24.5075C20.1747 24.3922 20.8179 24.6656 21.1704 25.2062C21.6277 25.9048 22.055 26.5394 22.4204 27.0757C22.7879 26.5373 23.213 25.9049 23.6703 25.2062C24.0228 24.6677 24.6659 24.3921 25.2984 24.5075C27.2107 24.8579 28.8793 25.5416 30.125 26.4903C31.5843 27.6013 32.3876 29.0435 32.3876 30.552C32.3876 32.4108 31.2274 34.088 29.1186 35.2717C27.3068 36.2909 24.9266 36.8528 22.4226 36.8528H22.4225ZM19.1065 27.8918C16.8588 28.5199 15.6602 29.6694 15.6602 30.5497C15.6602 31.9834 18.6129 33.6478 22.4223 33.6478C26.2317 33.6478 29.1845 31.9834 29.1845 30.5519C29.1845 29.6694 27.9837 28.52 25.7382 27.8939C24.5801 29.6288 23.7597 30.7634 23.7212 30.8168C23.42 31.2334 22.9371 31.4791 22.4222 31.4791C21.9073 31.4791 21.4244 31.2334 21.1231 30.8168C21.0847 30.7613 20.2642 29.6267 19.1062 27.8918H19.1065Z",
    fill: "url(#paint6_linear_4821_17473)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3979 50.5272H2.4435C1.97772 50.5272 1.53542 50.3242 1.23207 49.9738C0.928674 49.6213 0.791932 49.1555 0.85817 48.694L5.13136 19.4225C5.24674 18.6341 5.92189 18.0508 6.71669 18.0508H11.6736V21.2557H8.10124L4.29598 47.322H40.5436L36.7383 21.2557H33.166V18.0508H38.125C38.9198 18.0508 39.595 18.6341 39.7103 19.4225L43.9835 48.694C44.0497 49.1555 43.9151 49.6213 43.6096 49.9738C43.3062 50.3242 42.8639 50.5272 42.3982 50.5272H42.3979Z",
    fill: "url(#paint7_linear_4821_17473)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4246 16.4513C19.6451 16.4513 17.3848 14.191 17.3848 11.4115C17.3848 8.63194 19.6451 6.37158 22.4246 6.37158C25.2041 6.37158 27.4645 8.63194 27.4645 11.4115C27.4645 14.191 25.2041 16.4513 22.4246 16.4513ZM22.4246 9.57639C21.4119 9.57639 20.5894 10.3989 20.5894 11.4116C20.5894 12.4243 21.4119 13.2469 22.4246 13.2469C23.4373 13.2469 24.2599 12.4243 24.2599 11.4116C24.2599 10.4011 23.4373 9.57639 22.4246 9.57639Z",
    fill: "url(#paint8_linear_4821_17473)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4821_17473",
    x1: 29.077,
    y1: 34.6265,
    x2: 18.6513,
    y2: 30.6407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4821_17473",
    x1: 13.3188,
    y1: 34.6414,
    x2: 9.70458,
    y2: 32.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4821_17473",
    x1: 8.43505,
    y1: 37.194,
    x2: 3.2821,
    y2: 33.6364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4821_17473",
    x1: 39.8536,
    y1: 33.4814,
    x2: 30.2745,
    y2: 26.1066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4821_17473",
    x1: 34.8466,
    y1: 23.0181,
    x2: 28.9222,
    y2: 18.6252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4821_17473",
    x1: 31.1431,
    y1: 1.10802,
    x2: 8.41755,
    y2: -8.53384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4821_17473",
    x1: 30.2782,
    y1: 24.7136,
    x2: 17.658,
    y2: 12.6386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4821_17473",
    x1: 39.4333,
    y1: 18.6601,
    x2: 7.1802,
    y2: -6.79029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4821_17473",
    x1: 26.3979,
    y1: 6.5607,
    x2: 17.361,
    y2: 1.19473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D3970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B1529"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapIcon);
export default __webpack_public_path__ + "static/media/roadmap_icon.b9d09f4e292492a04074bcb3aa43da01.svg";
export { ForwardRef as ReactComponent };